import { get } from 'lodash';
import { extract } from '../RicosContentAPI/extract.js';
import { modify } from '../RicosContentAPI/modify.js';
import { compare } from './utils/comparator.js';
import '../ReadonlyNonEmptyArray-0e481d0b.js';
import 'ricos-schema';
import '../extractor-infra.js';
import '../Either-48abb652.js';
import '../index-a60c253d.js';
import '../ReadonlyRecord-86a56753.js';
import '../string-40bcd6bf.js';
import '../modifier-infra.js';
import '../converters/generateRandomId.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class Select {
  constructor(content, onSet) {
    var _a;
    this.extractor = extract((_a = content.nodes) != null ? _a : []);
    this.modifier = modify(content);
    this.content = content;
    this.onSet = onSet;
    this._limit = -1;
  }
  filter(predicate) {
    this.extractor = this.extractor.filter(predicate);
    this.modifier = this.modifier.filter(predicate);
    return this;
  }
  /**
   * executes query selection
   * @returns query result
   */
  get() {
    const results = this.extractor.get();
    if (this._limit >= 0) {
      return results.slice(0, this._limit);
    }
    return results;
  }
  eq(path, value) {
    return this.filter((node) => get(node, path) === value);
  }
  gt(path, value) {
    return this.filter((node) => compare(value, get(node, path)) > 0);
  }
  lt(path, value) {
    return this.filter((node) => compare(value, get(node, path)) < 0);
  }
  isEmpty(path) {
    return this.filter((node) => get(node, path) === void 0);
  }
  isNotEmpty(path) {
    return this.filter((node) => get(node, path) !== void 0);
  }
  startsWith(path, value) {
    return this.filter((node) => {
      var _a, _b;
      return (_b = (_a = get(node, path)) == null ? void 0 : _a.startsWith) == null ? void 0 : _b.call(_a, value);
    });
  }
  endsWith(path, value) {
    return this.filter((node) => {
      var _a, _b;
      return (_b = (_a = get(node, path)) == null ? void 0 : _a.endsWith) == null ? void 0 : _b.call(_a, value);
    });
  }
  contains(path, value) {
    return this.filter((node) => {
      var _a, _b;
      return (_b = (_a = get(node, path)) == null ? void 0 : _a.includes) == null ? void 0 : _b.call(_a, value);
    });
  }
  limit(count) {
    this._limit = count;
    return this;
  }
  count() {
    return this.get().length;
  }
  find() {
    return this.get();
  }
  modify(setter) {
    var _a;
    const root = this.modifier.set(setter);
    const modifiedContent = __spreadProps(__spreadValues({}, this.content), { nodes: root.nodes });
    (_a = this.onSet) == null ? void 0 : _a.call(this, modifiedContent);
    return modifiedContent;
  }
}
const select = (content, onSet) => new Select(content, onSet);

export { select };
//# sourceMappingURL=select.js.map
